import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';
import './vin-heart.scss';

export function VinHeart({
  active = false,
  disabled = false,
  onClick = null,
  trackingValue = '',
  isAuthenticated = false,
  className = '',
  spinnerSize = null,
  noSpinner = false,
}) {
  const trackingIdRules = {
    vin_save_vehicle: isAuthenticated && !active,
    vin_sign_up_progress: !isAuthenticated,
    vin_unsave_vehicle: isAuthenticated && active,
  };

  const dataTrackingValue = isAuthenticated ? trackingValue : 'save_vin';

  return (
    <Button
      color={active || disabled ? 'secondary' : 'primary'}
      outline={!active}
      className={classNames('vdp-heart-button vdp-text-decoration-none-hover pos-r border-0 animated', className, {
        active,
      })}
      disabled={disabled}
      onClick={onClick}
      data-tracking-id={classNames(trackingIdRules)}
      data-tracking-value={dataTrackingValue}
      title={active ? 'Remove this vehicle from favorites' : 'Save this vehicle to favorites'}
      aria-label={active ? 'Remove this vehicle from favorites' : 'Save this vehicle to favorites'}
    >
      <span className="d-flex h-100 justify-content-center align-items-center">
        <svg width={18} height={17} viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path
            d="M2.60586 1.53105C4.0571 0.556365 7.5 1.01789 9 3.69685C10.5 1.0179 13.9343 0.556366 15.383 1.53105C18.4479 3.59316 16.2928 7.32921 15.8662 7.86753C13.9346 10.3047 10.5 12.6651 9 13.5619C7.5 12.6651 3.40686 9.81748 2.12177 7.86753C1.7433 7.29325 -0.46449 3.59316 2.60586 1.53105Z"
            fill={active ? '#007EE5' : 'white'}
            stroke={active ? '#007EE5' : '#555555'}
            strokeWidth={2}
            strokeLinecap="round"
          />
        </svg>
      </span>
      {disabled && !noSpinner && (
        <span className="spinner-wrapper d-flex justify-content-center align-items-center bg-white w-100">
          <span>
            <Spinner color="primary" size={spinnerSize} />
          </span>
        </span>
      )}
    </Button>
  );
}

VinHeart.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  trackingValue: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  className: PropTypes.string,
  spinnerSize: PropTypes.number,
  noSpinner: PropTypes.bool,
};
